import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Registrar los componentes de Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ReporteMensualTablaClientesGraficaSectores = ({ rmDetalleSectoresPorcentualSeleccion }) => {

  // Ordenar los datos por porcentaje de mayor a menor
  const sortedData = [...rmDetalleSectoresPorcentualSeleccion].sort((a, b) => b.porcentaje - a.porcentaje);

  // Definir los datos para el gráfico de barras
  const baseHue = 203; // Hue correspondiente al color base #052f49
  const data = {
    labels: sortedData.map((item) => item.desc_prt_sector),
    datasets: [
      {
        label: 'Desglose x Sectores sobre el 5%',
        data: sortedData.map((item) => item.porcentaje),
        backgroundColor: sortedData.map(
          (item) => `hsl(${baseHue + item.row_num * 1.2}, 84%, 30%)` // Colores dinámicos a partir del color base
        ),
        borderColor: '#000',
        borderWidth: 1,
      },
    ],
  };

  // Opciones del gráfico
  const options = {
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        ticks: {
          callback: function (value) {
            return `${value}%`; // Muestra el porcentaje en el eje Y
          },
        },
      },
    },
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.raw}%`; // Tooltip con el porcentaje
          },
        },
      },
    },
  };

  return (
    <div>
      <Bar data={data} options={options} />
    </div>
  );
};

export default ReporteMensualTablaClientesGraficaSectores;
